import React, { useState, useEffect } from 'react';
import { useDiagnostico } from '../../../context/DiagnosticoContext/DiagnosticoHook';
import { getCategoriaEmpresa } from './functions';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

function ChatBar({
  dataChart,
  currentAnswer,
  textoPosicionY,
  textoPosicionX,
  indiceGrupoActual,
}) {
  const chartRef = React.useRef();
  const [loadChart, setloadChart] = useState(false);
  const { setChatStateFn, setLoadingTextFn } = useDiagnostico();
  useEffect(() => {
    if (loadChart) {
      // Si loadChart es verdadero, captura la imagen actual del gráfico como una cadena base64.
      const base64Image = chartRef.current.canvas.toDataURL('image/jpg');
      // Llama a setChatStateFn con la imagen capturada, almacenándola en un estado global o local.
      setChatStateFn({
        chart: { [`captura${indiceGrupoActual}`]: base64Image },
      });
    }
  }, [loadChart]); // Este efecto depende de loadChart, ejecutándos

  // Verifica que dataChart y currentAnswer estén definidos antes de continuar
  if (!dataChart || !currentAnswer) {
    return null; // O puedes devolver un componente de carga o un mensaje adecuado
  }
  // currentAnswer es un array de valores, necesito que me filtre los valores que sean solo numericos
  // y que me devuelva un array con los valores numericos
  const currentAnswerNumeric = currentAnswer.filter((item) => !isNaN(item));
  const findNumeric = currentAnswerNumeric.find((item) => item);
  if (!findNumeric) return;

  const typeOfEnterprise = getCategoriaEmpresa(findNumeric);

  const labels = [
    'Microempresa ',
    'Pequeña empresa',
    'Mediana empresa',
    'Grande empresa',
  ];

  const data = {
    labels,
    datasets: [
      {
        label: 'Número máximo de empleados',
        data: [10, 50, 200, 250], // 201 para representar "más de 200"
        backgroundColor: 'rgba(54, 162, 235, 0.2)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 1,
      },
      {
        label: 'Tu empresa',
        data: [null, null, null, null], // Inicializa todos los valores como null
        backgroundColor: 'rgba(255, 99, 132, 0.6)',
        borderColor: 'rgba(255, 99, 132, 1)',
        borderWidth: 2,
      },
    ],
  };

  // Coloca el número de empleados en la posición correcta
  data.datasets[1].data[typeOfEnterprise] = findNumeric;

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        title: {
          display: true,
          text: textoPosicionY ? [textoPosicionY] : [''],
        },
        beginAtZero: true,
      },
      x: {
        title: {
          display: true,
          text: textoPosicionX ? [textoPosicionX] : [''],
        },
        beginAtZero: true,
      },
    },
    plugins: {
      legend: {
        display: true,
      },
      title: {
        display: true,
        text: 'Clasificación de empresas por número de empleados',
      },
    },
    animation: {
      // Función que se llama automáticamente cuando la animación del gráfico se completa.
      onComplete: function () {
        // Verifica si el ref del gráfico y su canvas están disponibles para evitar errores.
        if (chartRef.current && chartRef.current.canvas) {
          // Establece loadChart a true, desencadenando el useEffect para capturar la imagen del gráfico.
          setloadChart(true);
          setLoadingTextFn(true);
        }
      },
    },
  };

  return (
    <div className="contenedorGrafica">
      <Bar
        options={options}
        data={data}
        ref={chartRef}
        width={'100%'}
        height={'100%'}
      />
    </div>
  );
}

export default ChatBar;
